import React from 'react';
import styles from './NavBar.module.css';

export function NavDivider() {
    return (
        <span className={styles.divider}>
         </span>
    );
}
